module.exports = __webpack_public_path__ + "static/media/logo.12cc06c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/AppHeader/assets/logo.svg
// module id = ./src/common/AppHeader/assets/logo.svg
// module chunks = 14